const defaultBaseUrl = process.env.REACT_APP_API_BASE_URL || '/api';

const jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const toError = async (response) => {
  let detail = '';
  try {
    const data = await response.json();
    detail = data?.message || data?.error || '';
  } catch (_error) {
    // ignore parse errors and fall back to status text
  }
  const message = detail || response.statusText || 'サーバーエラーが発生しました';
  const error = new Error(message);
  error.status = response.status;
  return error;
};

const request = async (path, { token, method = 'GET', body } = {}) => {
  const headers = { ...jsonHeaders };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${defaultBaseUrl}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    throw await toError(response);
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
};

export const login = async ({ id, password }) =>
  request('/auth/login', { method: 'POST', body: { id, password } });

export const fetchWorkouts = async (token) =>
  request('/workouts', { token }).then((data) => data?.workouts ?? []);

export const fetchGoal = async (token) =>
  request('/goal', { token }).then((data) => data?.text ?? '');

export const updateGoal = async (token, text) =>
  request('/goal', { token, method: 'PUT', body: { text } }).then(
    (data) => data?.text ?? text
  );

export const createWorkout = async (token, name) =>
  request('/workouts', { token, method: 'POST', body: { name } });

export const addWorkoutSet = async (token, workoutId, { weight, reps, recordedAt }) =>
  request(`/workouts/${encodeURIComponent(workoutId)}/sets`, {
    token,
    method: 'POST',
    body: { weight, reps, recordedAt },
  });

export const deleteWorkoutSet = async (token, workoutId, setId) =>
  request(
    `/workouts/${encodeURIComponent(workoutId)}/sets/${encodeURIComponent(setId)}`,
    {
      token,
      method: 'DELETE',
    }
  );

export const updateWorkout = async (token, workoutId, payload) =>
  request(`/workouts/${encodeURIComponent(workoutId)}`, {
    token,
    method: 'PATCH',
    body: payload,
  });
